import {
  BadgePercentIcon, BedIcon, Building2Icon, CakeIcon, CalendarIcon, CircleDotIcon, CreditCardIcon, FileCheckIcon,
  GraduationCapIcon, HashIcon, HeartPulseIcon, LandmarkIcon, MapIcon, MapPinIcon, MessageCircleQuestionIcon,
  ReceiptIcon, RulerIcon, ShieldAlertIcon, ShieldPlusIcon, ShirtIcon, SparklesIcon, StethoscopeIcon, StickyNoteIcon,
  TagIcon, TentTreeIcon, TicketIcon, TimerIcon, UserIcon, UserRoundPlusIcon, UsersIcon, VenusAndMarsIcon, WalletIcon,
} from 'lucide-react';

export const columnIcons = {
  bookingDate: CalendarIcon,
  participant: UserIcon,
  bookingNumber: HashIcon,
  program: TentTreeIcon,
  status: CircleDotIcon,
  statusNote: StickyNoteIcon,
  stay: BedIcon,
  age: TimerIcon,
  grade: GraduationCapIcon,
  dob: CakeIcon,
  gender: VenusAndMarsIcon,
  primaryGuardian: UsersIcon,
  secondaryGuardian: UserRoundPlusIcon,
  address: MapPinIcon,
  apt: Building2Icon,
  city: LandmarkIcon,
  state: MapIcon,
  zip: HashIcon,
  extras: SparklesIcon,
  additionalCharge: ReceiptIcon,
  tshirtSize: ShirtIcon,
  shortsSize: RulerIcon,
  payment: CreditCardIcon,
  paymentType: WalletIcon,
  couponCode: TicketIcon,
  couponAmount: BadgePercentIcon,
  insuranceCompany: ShieldPlusIcon,
  documents: FileCheckIcon,
  medicalReview: StethoscopeIcon,
  medical: HeartPulseIcon,
  allergy: ShieldAlertIcon,
  groupCode: TagIcon,
};

// A key with no icon of its own gets a generic one.
export const iconFor = key => columnIcons[key] || MessageCircleQuestionIcon;
